export default {
  name: 'Panelcommission',
  props: ['selectedComissao'],
  mounted () {
    this.statusColor.backgroundColor = ['#30a75f', '#db3939', '#f6b535'][this.selectedComissao.status]
    this.statusText = ['Quitado', 'Atrasado', 'Em Andamento'][this.selectedComissao.status]
  },
  data () {
    return {
      statusText: '',
      statusColor: {
        backgroundColor: ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/commissioncheck/components/panelcommission/panelcommission.js